import { render, staticRenderFns } from "./IconArrowNarrowLeftSolid.vue?vue&type=template&id=09122d76"
import script from "./IconArrowNarrowLeftSolid.vue?vue&type=script&lang=js"
export * from "./IconArrowNarrowLeftSolid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports